<script setup lang="ts">
import bannerContent from "~/assets/scss/static/123@2x.png";
import platformTitle from "~/assets/scss/static/组 1737@2x.png";

const stats = [
  {
    value: "10",
    unit: "万+",
    label: "卡券交易数",
  },
  {
    value: "51",
    unit: "万+",
    label: "充值服务金额",
  },
  {
    value: "1.3",
    unit: "万+",
    label: "任务数量",
  },
  {
    value: "2.45",
    unit: "万+",
    label: "已服务用户",
  },
];
</script>

<template>
  <section class="merchant-hero">
    <div class="merchant-hero__visual">
      <img
        class="merchant-hero__banner"
        :src="bannerContent"
        alt="专业商品采购平台 智能与数字化"
      />

      <div class="merchant-hero__dots" aria-hidden="true">
        <span class="merchant-hero__dot merchant-hero__dot--active"></span>
        <span class="merchant-hero__dot"></span>
        <span class="merchant-hero__dot"></span>
      </div>
    </div>

    <div class="merchant-stats">
      <div class="merchant-stats__intro">
        <img :src="platformTitle" alt="专业化平台 卡券、充值等虚拟产品服务" />
      </div>
      <div v-for="item in stats" :key="item.label" class="merchant-stats__item">
        <div class="merchant-stats__value">
          <span>{{ item.value }}</span
          ><em>{{ item.unit }}</em>
        </div>
        <div class="merchant-stats__label">{{ item.label }}</div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.merchant-hero {
  position: relative;
  overflow: visible;
  padding-bottom: 34px;

  &__visual {
    position: relative;
    width: 100%;
  }

  &__banner {
    display: block;
    width: 100%;
    height: min(37vw, 634px);
    aspect-ratio: 3840 / 1400;
    object-fit: cover;
    object-position: center top;
    user-select: none;
    pointer-events: none;
  }

  &__dots {
    position: absolute;
    left: 50%;
    bottom: 13%;
    z-index: 2;
    display: flex;
    align-items: center;
    gap: 10px;
    transform: translateX(-50%);
  }

  &__dot {
    width: 28px;
    height: 5px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.55);

    &--active {
      width: 42px;
      background: #fff;
    }
  }
}

.merchant-stats {
  position: absolute;
  left: 50%;
  bottom: -9px;
  z-index: 3;
  display: grid;
  grid-template-columns: 250px repeat(4, 1fr);
  width: min(1100px, calc(100% - 96px));
  min-height: 80px;
  overflow: hidden;
  transform: translateX(-50%);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 12px 26px rgba(47, 107, 171, 0.12);

  &__intro,
  &__item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-width: 0;
    text-align: center;
    // width: 100px;
    // height: 100px;
  }

  &__intro {
    background: #fff8f2;

    img {
      display: block;
      width: 232px;
      height: auto;
    }
  }

  &__value {
    color: #122033;
    font-weight: 800;
    line-height: 1;

    span {
      font-size: 29px;
    }

    em {
      margin-left: 1px;
      font-style: normal;
      font-size: 13px;
    }
  }

  &__label {
    margin-top: 9px;
    color: #27384c;
    font-size: 13px;
    line-height: 1;
  }
}

@media (max-width: 1200px) {
  .merchant-stats {
    grid-template-columns: 220px repeat(4, 1fr);
  }
}

@media (max-width: 768px) {
  .merchant-hero {
    padding-bottom: 48px;
  }

  .merchant-stats {
    bottom: -150px;
    grid-template-columns: repeat(2, 1fr);
    width: calc(100% - 32px);

    &__intro {
      grid-column: 1 / -1;
      padding: 18px 0;
    }

    &__item {
      min-height: 78px;
    }
  }
}
</style>
